(() => {
  const headingCopy = 'Ways to partner';
  const opportunityCopy = new Map([
    ['Affiliate marketing', 'Affiliate links'],
    ['Discount codes', 'Audience discounts'],
    ['Additional opportunities', 'Custom collaborations'],
    ['Campaigns', 'Creator campaigns'],
  ]);
  const existingShowcaseAlts = [
    'A custom desk mat featuring a pet portrait',
    'A custom desk mat featuring colorful creator artwork',
    'A custom desk mat featuring bold red and black artwork',
    'A branded desk mat featuring a custom creator logo',
  ];

  function clarifyCollabsOpportunities(scope = document) {
    scope.querySelectorAll('.template-page-collabs .collabs-page__partnership').forEach((partnership) => {
      const heading = partnership.querySelector('h2');
      if (heading?.textContent.trim() === 'Partnership opportunities') {
        heading.textContent = headingCopy;
      }

      partnership.querySelectorAll('.collabs-page__partnership-list li').forEach((item) => {
        const replacement = opportunityCopy.get(item.textContent.trim());
        if (replacement) item.textContent = replacement;
      });
    });
  }

  function addShowcaseImages() {
    const gallery = document.querySelector('.template-page-collabs .collabs-page__images');
    const template = document.querySelector('.affiliate-program__showcase-template');

    if (!gallery || !template) return false;
    if (gallery.querySelector('[data-affiliate-showcase-image]')) return true;

    gallery.querySelectorAll('img').forEach((image, index) => {
      if (!image.alt.trim() && existingShowcaseAlts[index]) {
        image.alt = existingShowcaseAlts[index];
      }
    });

    gallery.append(template.content.cloneNode(true));
    return true;
  }

  function enhanceCollabsPage(attempt = 0) {
    clarifyCollabsOpportunities();

    if (!addShowcaseImages() && attempt < 20) {
      window.setTimeout(() => enhanceCollabsPage(attempt + 1), 250);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => enhanceCollabsPage(), { once: true });
  } else {
    enhanceCollabsPage();
  }

  document.addEventListener('shopify:section:load', () => enhanceCollabsPage());
})();
